export default {
    openUrl(url,code){
        window.open(url+'?code='+code)
    },
    //判断是否为空 
    isEmpty: function (data) {
        if ((data == '' || data == null || data == undefined || data == 'null') && data !== 0) {
            return true;
        } else {
            return false;
        }
    },
    //解决对象的浅拷贝
    copyObj: function (obj) {
        return JSON.parse(JSON.stringify(obj))
    },
    removeLocal: function(key) {
        localStorage.removeItem(key);
    },
    formatTel: function (tel) {
        var reg = /^(\d{3})\d{4}(\d{4})$/;
        return tel.replace(reg, "$1****$2");
    },
    // 指定时间转换为时间戳
    toTimeStamp: function (dateString) {
        // dateString例如:'2022-03-05'
        // 例如返回:1646611200000
        return new Date(dateString) - 0
    },
    // 计算两个日期距离的天数
    getDistanceDays: function (date1, date2) {
        var time1 = new Date(date1);
        var time2 = new Date(date2);
        var cha = time1.getTime() - time2.getTime(); //毫秒
        // var s = parseInt(cha / 1000 % 60)//秒 余下多少秒（0-59）
        var m = parseInt(cha / 1000 / 60 % 60) + 1; //余下了多少分钟（0-59）
        var h = parseInt(cha / 1000 / 60 / 60 % 24); //余下多少时（0-23）
        //进行补0操作
        // s = s < 10 ? '0' + s : s;
        h = h < 10 ? '0' + h : h;
        m = m < 10 ? '0' + m : m;
        //获取多少天
        var t = parseInt(cha / 1000 / 60 / 60 / 24).toString();
        var params = new Array(t, h, m)
        // return t + '天' + h + ':' + m
        return params
    },
    returnFloat: function (val) {
        var value = Math.round(parseFloat(val) * 100) / 100;
        var xsd = value.toString().split(".");
        if (xsd.length == 1) {
            value = value.toString() + ".00";
            return value;
        }
        if (xsd.length > 1) {
            if (xsd[1].length < 2) {
                value = value.toString() + "0";
            }
            return value;
        }
    }
}